export type SortOption = { value: string; label: string }

export const SORT_OPTIONS: SortOption[] = [
  { value: 'latest', label: 'Сүүлд нэмэгдсэн' },
  { value: 'old', label: 'Хуучинаас шинэ' },
  { value: 'inc', label: 'Үнэ өсөхөөр' },
  { value: 'dec', label: 'Үнэ буурахаар' },
  { value: 'sale', label: 'Хямдралын хувиар' },
]

export const SPECIAL_CATEGORY_FILTERS = ['featured', 'new', 'sale', 'preorder', 'loyalty'] as const
export type SpecialCategoryFilter = typeof SPECIAL_CATEGORY_FILTERS[number]

export const SPECIAL_CATEGORY_LABELS: Record<SpecialCategoryFilter, string> = {
  featured: 'Онцлох',
  new: 'Шинэ',
  sale: 'Хямдралтай',
  preorder: 'Захиалгат',
  loyalty: 'Лояалти',
}

export function findCategoryById(categories: any[], id: string): any {
  for (const category of categories) {
    if (category.id === id || category.slug === id) return category
    if (category.children) {
      const found = findCategoryById(category.children, id)
      if (found) return found
    }
  }
  return null
}

export function getCategoryDescendantIds(category: any): string[] {
  if (!category) return []
  const ids: string[] = [category.id]
  if (category.children) {
    for (const child of category.children) {
      ids.push(child.id)
      if (child.children) {
        for (const grand of child.children) ids.push(grand.id)
      }
    }
  }
  return ids
}

export type ProductListFilters = {
  category: string | null
  brand: string | null
  tag: string | null
  sort: string
  filter: string | null
  search: string | null
}

export function buildInitialProductFilters(searchParams: URLSearchParams | { get: (key: string) => string | null }, categoryList: any[]): ProductListFilters {
  const categoryParam = searchParams.get('category')
  const brandParam = searchParams.get('brand')
  const tagParam = searchParams.get('tag')

  let categoryIds: string[] = []
  if (categoryParam && !SPECIAL_CATEGORY_FILTERS.includes(categoryParam as SpecialCategoryFilter)) {
    const found = findCategoryById(categoryList, categoryParam)
    categoryIds = found ? getCategoryDescendantIds(found) : [categoryParam]
  }

  const isSpecial = SPECIAL_CATEGORY_FILTERS.includes(categoryParam as SpecialCategoryFilter)
  return {
    category: categoryIds.length > 0 ? categoryIds.join(',') : null,
    brand: brandParam || null,
    tag: tagParam || null,
    sort: 'latest',
    filter: isSpecial ? categoryParam : null,
    search: searchParams.get('search') || null,
  }
}
